/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet-async';
import {Edit} from '@mui/icons-material';
import {useNavigate, useLocation, useSearchParams} from 'react-router-dom';
import {Grid, TableCell, TableBody, IconButton} from '@mui/material';
import {FilterList as FilterListIcon} from '@mui/icons-material';
import {DateRange} from '@mui/lab/DateRangePicker';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {POINT_SUCCESS, POINT_SUCCESS_COLOR} from '../../../constants/status';

import {ColorType} from '../../../types/typeChip';
import {Breadcrumbs, Chip, Table, Tooltips, Button} from '../../../components';
import {path} from '../../../routes/path';
import {
  ColumnsType,
  RowType,
  typeRoutes,
} from '../../../types/typeReferralTransactions';
import ModalFilter from './components/ModalFilter/ModalFilter';
import {
  envRole,
  getEndOfDate,
  getStartOfDate,
  hasPermission,
} from '../../../utils';
import useAuth from '../../../hooks/useAuth';
import {USER_TYPE} from '../../../constants/UserType';
import {formatLocalDateFromUTCTime} from '../../../utils';
import queryString from 'query-string';
import ReferralTransactionService from '../../../services/ReferralProgramme/referral-transaction.service';
import ExportExcelService from '../../../services/ExportExcel/ExportExcel';
import success from '../../../constants/success';

// Style
import {
  Divider,
  StyledTableRow,
  Typography,
  StyledStack,
  StyledAction,
  StyledIcon,
} from './ReferralTransactions.style';
import {number} from 'yup';
import {rbacPermissions} from '../../../constants/roleBasedAccessControlConstants';

function ReferralTransactions() {
  const navigate = useNavigate();
  const localtionParams = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const formatDateTime = 'DD/MM/YYYY HH:mm';
  const formatDate = 'DD/MM/YYYY';
  const {getUser, showNotification, checkRbac} = Object.assign(useAuth());
  const user = getUser() || {};
  const {email} = user;
  const referralTxnMembershipId =
    localtionParams.state?.referralTxnMembershipId;
  const referralTxnMembershipLabel =
    localtionParams.state?.referralTxnMembershipLabel;
  const role =
    +envRole === USER_TYPE.ADMINISTRATOR ? 'administrator' : 'merchant';
  const canUpdate = hasPermission(path.ISLAND_MEMBERS, 'update');
  // states
  const [order] = useState<'desc' | 'asc'>('asc');
  const [orderBy] = useState('');
  const [dense] = useState(false);
  const [isModalFilter, setIsModalFilter] = useState(false);
  const [focusId, setFocusId] = useState(null);
  const [isLoadingExport, setIsLoadingExport] = useState(false);
  const [dataSource, setDataSource] = useState<Array<RowType>>([]);
  const [totalPage, setTotalPage] = useState(0);
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [optionByType, setOptionByType] = useState([]);
  const [nameContainsList, setNameContainsList] = useState([]);
  const [valueFilter, setValueFilter] = useState({
    referralType_eq: searchParams.get('referralType_eq') ?? '',
    referralCampaignNumberId_eq:
      searchParams.get('referralCampaignNumberId_eq') ?? '',
    accountId_eq: searchParams.get('accountId_eq') ?? '',
    processId_eq: searchParams.get('processId_eq') ?? '',
    pointsStatus_eq: searchParams.get('pointsStatus_eq') ?? '',
    pointsRewarded_lte: searchParams.get('pointsRewarded_lte') ?? '',
    pointsRewarded_gte: searchParams.get('pointsRewarded_gte') ?? '',
    transactionId_eq: searchParams.get('transactionId_eq') ?? '',
    referralCodeUsed_eq: searchParams.get('referralCodeUsed_eq') ?? '',
    createdDateTime_lte: searchParams.get('createdDateTime_lte') ?? '',
    createdDateTime_gte: searchParams.get('createdDateTime_gte') ?? '',
    pointsExpireDateTime_lt: searchParams.get('pointsExpireDateTime_lt') ?? '',
    pointsExpireDateTime_gte:
      searchParams.get('pointsExpireDateTime_gte') ?? '',
    referralTxnMembershipId_eq:
      referralTxnMembershipId ||
      (searchParams.get('referralTxnMembershipId_eq') ?? ''),
    referralTxnMembershipId_label:
      referralTxnMembershipLabel ||
      (searchParams.get('referralTxnMembershipId_label') ?? ''),
  });
  const [valueRangePicker, setValueRangePicker] = useState<DateRange<Date>>([
    null,
    null,
  ]);
  const [expireValueRangePicker, setExpireValueRangePicker] = useState<
    DateRange<Date>
  >([null, null]);
  const searchParamsObject = queryString.parse(searchParams.toString());
  const [numberRange, setNumberRange] = useState<any>({
    start: searchParamsObject.pointsRewarded_gte ?? null,
    end: searchParamsObject.pointsRewarded_lte ?? null,
  });
  const [params, setParams] = useState({
    _page: 0,
    _size: 10,
    _sort: 'createdDateTime:desc',
    pointsStatus_eq: searchParamsObject.pointsStatus_eq ?? undefined,
    referralCampaignNumberId_eq:
      searchParamsObject.referralCampaignNumberId_eq ?? undefined,
    referralCodeUsed_eq: searchParamsObject.referralCodeUsed_eq ?? undefined,
    processId_eq: searchParamsObject.processId_eq ?? undefined,
    accountId_eq: searchParamsObject.accountId_eq ?? undefined,
    pointsExpireDateTime_lt:
      searchParamsObject.pointsExpireDateTime_lt ?? undefined,
    pointsExpireDateTime_gte:
      searchParamsObject.pointsExpireDateTime_gte ?? undefined,
    referralTxnMembershipId_eq:
      searchParamsObject.referralTxnMembershipId_eq ?? undefined,
    referralTxnMembershipId_label:
      searchParamsObject.referralTxnMembershipId_label ?? undefined,
    pointsRewarded_lte: searchParamsObject.pointsRewarded_lte ?? undefined,
    pointsRewarded_gte: searchParamsObject.pointsRewarded_gte ?? undefined,
    transactionId_eq: searchParamsObject.transactionId_eq ?? undefined,
  });

  const PARTNERSHIP = '1';
  const ISLANDER_MEMBER = '2';

  const referralType_eq_LIST = {
    [PARTNERSHIP]: 'Partnership',
    [ISLANDER_MEMBER]: 'Islander Member',
  };

  const COMPLETE = '1';
  const PENDING = '2';
  const DECLINED = '3';

  const processId_eq_LIST = {
    [COMPLETE]: 'Approved',
    [PENDING]: 'Pending',
    [DECLINED]: 'Declined',
  };

  const columns: Array<ColumnsType> = [
    {
      dataIndex: 'referralCampaignTransactionId',
      numeric: false,
      disablePadding: false,
      label: 'Transaction no.',
    },
    {
      dataIndex: 'referralDateTime',
      numeric: false,
      disablePadding: false,
      label: 'Referral transaction date and time',
    },
    {
      dataIndex: 'refereeAccountId',
      numeric: false,
      disablePadding: false,
      label: 'Referee’s Account ID',
    },
    {
      dataIndex: 'referralCodeUsed',
      numeric: false,
      disablePadding: false,
      label: 'Referral code used',
    },
    {
      dataIndex: 'referralCreationId',
      numeric: false,
      disablePadding: false,
      label: 'Referral Creation ID',
    },
    {
      dataIndex: 'referralType',
      numeric: false,
      disablePadding: false,
      label: 'Referral type',
    },
    {
      dataIndex: 'referrerTransactionStatus',
      numeric: false,
      disablePadding: false,
      label: 'Transaction status',
    },
    {
      dataIndex: 'pointsRewarded',
      numeric: false,
      disablePadding: false,
      label: 'Points rewarded',
    },
    {
      dataIndex: 'referralExpiryDateTime',
      numeric: false,
      disablePadding: false,
      label: 'Points expiry date and time',
    },
    {
      dataIndex: 'status',
      numeric: false,
      disablePadding: false,
      label: 'Points status',
    },
    {
      dataIndex: null,
      numeric: false,
      disablePadding: false,
      label: '',
    },
  ];

  const getExport = () => {
    setIsLoadingExport(true);
    new ExportExcelService()
      .exportReferralCampaignTransactions({
        ...params,
        email: email,
        processId_eq:
          Number(params?.processId_eq) === POINT_SUCCESS.EXPIRED
            ? undefined
            : params.processId_eq,
      })
      .then(res => {
        setIsLoadingExport(false);
        if (res && res?.success) {
          showNotification({
            message: success.EXPORT_SUCCESS,
          });
        } else {
          showNotification({
            message: res?.errorMessage,
            variation: 'error',
          });
        }
      });
  };

  const onChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setParams(preState => ({
      ...preState,
      _page: newPage,
    }));
  };

  const onChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setParams(preState => ({
      ...preState,
      _page: 0,
      _size: parseInt(event.target.value, 10),
    }));
  };

  const onClickIconButton = idTransaction => {
    return navigate(
      `/${path.REFERRAL_PROGRAMME}/${path.REFERRAL_TRANSACTIONS}/${idTransaction}`
    );
  };

  const renderExpiredDateTime = (details: any) => {
    if (details.processId !== 1) return '--';
    return formatLocalDateFromUTCTime(details.expiryDateTime, formatDateTime);
  };

  const renderPointsStatus = (details: any) => {
    if (details.processId !== 1) return '--';
    let label = '--';
    let color = '';
    switch (details.status) {
      case 1:
        label = 'Active';
        color = 'success';
        break;
      case 2:
        label = 'Expired';
        color = 'error';
        break;
      default:
        return '--';
    }
    return <Chip label={label} color={color as ColorType} />;
  };

  const renderStatus = (value: any) => {
    let label = '--';
    let color = 'default';
    switch (value.processId) {
      case 1:
        label = processId_eq_LIST[value.processId];
        color = POINT_SUCCESS_COLOR[value.processId];
        break;
      case 2:
        label = processId_eq_LIST[value.processId];
        color = POINT_SUCCESS_COLOR[value.processId];
        break;
      case 3:
        label = processId_eq_LIST[value.processId];
        color = POINT_SUCCESS_COLOR[value.processId];
        break;
      default:
        break;
    }
    return <Chip label={label} color={color as ColorType} />;
  };

  const renderLabelChip = (status: number) => {
    let label = '--';
    switch (status) {
      case 1:
        label = 'Active';
        break;
      case 2:
        label = 'Expired';
        break;
      default:
        return '--';
    }
    return label;
  };

  const renderReferralType = (details: any) => {
    switch (details.referralType) {
      case 1:
        return 'Partnership';
      case 2:
        return 'Islander Member';
      default:
        return '--';
    }
  };

  const renderAction = (value: string | number) => {
    if (!canUpdate) {
      if (focusId === value) {
        return (
          <StyledAction>
            <Tooltips title="View detail">
              <IconButton
                aria-label="details"
                size="medium"
                onClick={() => {
                  onClickIconButton(value);
                }}
              >
                <VisibilityIcon style={StyledIcon} />
              </IconButton>
            </Tooltips>
          </StyledAction>
        );
      }
    }
    if (focusId === value) {
      return (
        <StyledAction>
          <Tooltips title="Edit">
            <IconButton
              aria-label="details"
              onClick={() => {
                onClickIconButton(value);
              }}
              size="medium"
            >
              <Edit style={StyledIcon} />
            </IconButton>
          </Tooltips>
        </StyledAction>
      );
    }
  };

  const deleteSearchParams = key => {
    if (searchParams.has(key)) {
      searchParams.delete(key);
      setSearchParams(searchParams);
    }
  };

  const handleDeleteChip = (type: string) => {
    if (type === 'date') {
      deleteSearchParams('createdDateTime_lte');
      deleteSearchParams('createdDateTime_gte');
      setValueRangePicker([null, null]);
      setValueFilter({
        ...valueFilter,
        createdDateTime_lte: '',
        createdDateTime_gte: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        createdDateTime_lte: undefined,
        createdDateTime_gte: undefined,
      }));
    }

    if (type === 'expireDate') {
      deleteSearchParams('pointsExpireDateTime_lt');
      deleteSearchParams('pointsExpireDateTime_gte');
      setExpireValueRangePicker([null, null]);
      setValueFilter({
        ...valueFilter,
        pointsExpireDateTime_lt: '',
        pointsExpireDateTime_gte: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        pointsExpireDateTime_lt: undefined,
        pointsExpireDateTime_gte: undefined,
      }));
    }

    if (type === 'referralType_eq') {
      deleteSearchParams('referralType_eq');
      deleteSearchParams('referralType_label');
      setValueFilter({
        ...valueFilter,
        referralType_eq: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        referralType_eq: undefined,
      }));
    }

    if (type === 'referralCampaignNumberId_eq') {
      deleteSearchParams('referralCampaignNumberId_eq');
      setValueFilter({
        ...valueFilter,
        referralCampaignNumberId_eq: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        referralCampaignNumberId_eq: undefined,
      }));
    }

    if (type === 'referralCodeUsed_eq') {
      deleteSearchParams('referralCodeUsed_eq');
      setValueFilter({
        ...valueFilter,
        referralCodeUsed_eq: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        referralCodeUsed_eq: undefined,
      }));
    }

    if (type === 'accountId_eq') {
      setValueFilter({
        ...valueFilter,
        accountId_eq: '',
      });
      deleteSearchParams('accountId_eq');
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        accountId_eq: undefined,
      }));
    }

    if (type === 'referralTxnMembershipId_label') {
      setValueFilter({
        ...valueFilter,
        referralTxnMembershipId_label: '',
        referralTxnMembershipId_eq: '',
      });
      deleteSearchParams('referralTxnMembershipId_label');
      deleteSearchParams('referralTxnMembershipId_eq');
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        referralTxnMembershipId_label: undefined,
        referralTxnMembershipId_eq: undefined,
      }));
    }

    if (type === 'processId_eq') {
      setValueFilter({
        ...valueFilter,
        processId_eq: '',
      });
      deleteSearchParams('processId_eq');
      deleteSearchParams('processId_label');
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        processId_eq: undefined,
      }));
    }

    if (type === 'pointsRewarded_gte') {
      setValueFilter({
        ...valueFilter,
        pointsRewarded_gte: '',
      });
      setNumberRange({...numberRange, start: null});
      deleteSearchParams('pointsRewarded_gte');
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        pointsRewarded_gte: undefined,
      }));
    }

    if (type === 'pointsRewarded_lte') {
      setValueFilter({
        ...valueFilter,
        pointsRewarded_lte: '',
      });
      setNumberRange({...numberRange, end: null});
      deleteSearchParams('pointsRewarded_lte');
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        pointsRewarded_lte: undefined,
      }));
    }

    if (type === 'pointsRewarded') {
      setValueFilter({
        ...valueFilter,
        pointsRewarded_lte: '',
        pointsRewarded_gte: '',
      });
      setNumberRange({end: null, start: null});
      deleteSearchParams('pointsRewarded_lte');
      deleteSearchParams('pointsRewarded_gte');
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        pointsRewarded_lte: undefined,
        pointsRewarded_gte: undefined,
      }));
    }
    if (type === 'pointsStatus_eq') {
      setValueFilter({
        ...valueFilter,
        pointsStatus_eq: '',
      });
      deleteSearchParams('pointsStatus_eq');
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        pointsStatus_eq: undefined,
      }));
    }

    if (type === 'transactionId_eq') {
      setValueFilter({
        ...valueFilter,
        transactionId_eq: '',
      });
      deleteSearchParams('transactionId_eq');
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        transactionId_eq: undefined,
      }));
    }
  };

  const toggleModal = () => {
    setIsModalFilter(!isModalFilter);
  };

  const handleClean = () => {
    setValueRangePicker([null, null]);
    setExpireValueRangePicker([null, null]);
    setNumberRange({start: null, end: null});
    setValueFilter({
      referralType_eq: '',
      referralCampaignNumberId_eq: '',
      accountId_eq: '',
      createdDateTime_lte: '',
      createdDateTime_gte: '',
      pointsExpireDateTime_lt: '',
      pointsExpireDateTime_gte: '',
      processId_eq: '',
      referralCodeUsed_eq: '',
      transactionId_eq: '',
      pointsRewarded_gte: '',
      pointsRewarded_lte: '',
      pointsStatus_eq: '',
    });
    deleteSearchParams('referralType_eq');
    deleteSearchParams('pointsStatus_eq');
    deleteSearchParams('pointsRewarded_lte');
    deleteSearchParams('pointsRewarded_gte');
    deleteSearchParams('referralCodeUsed_eq');
    deleteSearchParams('pointsExpireDateTime_gte');
    deleteSearchParams('pointsExpireDateTime_lt');
    deleteSearchParams('createdDateTime_gte');
    deleteSearchParams('createdDateTime_lte');
    deleteSearchParams('accountId_eq');
    deleteSearchParams('referralCampaignNumberId_eq');
    deleteSearchParams('referralType_label');
    deleteSearchParams('processId_label');
    deleteSearchParams('referralTxnMembershipId_label');
    deleteSearchParams('processId_eq');
  };

  const handleFilter = () => {
    if (valueFilter?.processId_eq) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        processId_eq: valueFilter?.processId_eq,
      }));
    } else {
      handleDeleteChip('processId_eq');
    }

    if (valueFilter?.referralType_eq) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        referralType_eq: valueFilter?.referralType_eq,
      }));
    } else {
      handleDeleteChip('referralType_eq');
    }

    if (valueFilter?.transactionId_eq) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        transactionId_eq: valueFilter?.transactionId_eq,
      }));
    } else {
      handleDeleteChip('transactionId_eq');
    }

    if (valueFilter?.pointsRewarded_lte) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        pointsRewarded_lte: valueFilter?.pointsRewarded_lte,
      }));
    } else if (numberRange?.end) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        pointsRewarded_lte: numberRange?.end,
      }));
    } else {
      handleDeleteChip('pointsRewarded_lte');
    }

    if (valueFilter?.pointsRewarded_gte) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        pointsRewarded_gte: valueFilter?.pointsRewarded_gte,
      }));
    } else if (numberRange?.start) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        pointsRewarded_gte: numberRange?.start,
      }));
    } else {
      handleDeleteChip('pointsRewarded_gte');
    }

    if (valueFilter?.pointsStatus_eq) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        pointsStatus_eq: valueFilter?.pointsStatus_eq ?? undefined,
      }));
    } else {
      handleDeleteChip('pointsStatus_eq');
    }

    if (valueRangePicker[0] || valueRangePicker[1]) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        createdDateTime_lte: getEndOfDate(valueRangePicker[1], formatDateTime),
        createdDateTime_gte: getStartOfDate(
          valueRangePicker[0],
          formatDateTime
        ),
      }));
    } else if (
      valueFilter?.createdDateTime_lte !== '' ||
      valueFilter?.createdDateTime_gte !== ''
    ) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        createdDateTime_lte: valueFilter?.createdDateTime_lte,
        createdDateTime_gte: valueFilter?.createdDateTime_gte,
      }));
    } else {
      handleDeleteChip('date');
    }

    if (expireValueRangePicker[0] || expireValueRangePicker[1]) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        pointsExpireDateTime_lt: getEndOfDate(
          expireValueRangePicker[1],
          formatDateTime
        ),
        pointsExpireDateTime_gte: getStartOfDate(
          expireValueRangePicker[0],
          formatDateTime
        ),
      }));
    } else if (
      valueFilter?.pointsExpireDateTime_lt !== '' ||
      valueFilter?.pointsExpireDateTime_gte !== ''
    ) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        pointsExpireDateTime_lt: valueFilter?.pointsExpireDateTime_lt,
        pointsExpireDateTime_gte: valueFilter?.pointsExpireDateTime_gte,
      }));
    } else {
      handleDeleteChip('expireDate');
    }

    if (valueFilter?.referralCampaignNumberId_eq) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        referralCampaignNumberId_eq: valueFilter?.referralCampaignNumberId_eq,
      }));
    } else {
      handleDeleteChip('referralCampaignNumberId_eq');
    }

    if (valueFilter?.accountId_eq) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        accountId_eq: valueFilter?.accountId_eq,
      }));
    } else {
      handleDeleteChip('accountId_eq');
    }

    if (valueFilter?.referralCodeUsed_eq) {
      setParams(preState => ({
        ...preState,
        _page: 0,
        referralCodeUsed_eq: valueFilter?.referralCodeUsed_eq,
      }));
    } else {
      handleDeleteChip('referralCodeUsed_eq');
    }

    toggleModal();
  };

  const getListTransaction = () => {
    setIsLoading(true);
    if (role) {
      new ReferralTransactionService()
        .getAll({
          ...params,
        })
        .then(res => {
          if (res?.data && Array.isArray(res.data.items)) {
            setDataSource(res.data.items);
            setTotalPage(res?.data?.total);
            setIsLoading(false);
          }
        })
        .catch(error => {
          setIsLoading(false);
          // Get api error => show notification or no items listing
          setError(error);
        });
    }
  };

  const renderAccountIdEq = () => {
    if (
      nameContainsList.length === 0 &&
      searchParams.get('accountId_eq') !== null
    ) {
      setSearchParams(
        queryString.stringify({
          ...params,
          referralType_label: referralType_eq_LIST[valueFilter.referralType_eq],
          processId_label: processId_eq_LIST[valueFilter.processId_eq],
          accountId_eq: searchParams.get('accountId_eq'),
        })
      );
      return searchParams.get('accountId_eq');
    }
    return;
  };

  useEffect(() => {
    setSearchParams(
      queryString.stringify({
        ...params,
        referralType_label: referralType_eq_LIST[valueFilter.referralType_eq],
        processId_label: processId_eq_LIST[valueFilter.processId_eq],
      })
    );

    renderAccountIdEq();
    getListTransaction();
  }, [params]);

  return (
    <React.Fragment>
      <Helmet title="Referral Transactions" />

      <ModalFilter
        referralTypeList={referralType_eq_LIST}
        processIdList={processId_eq_LIST}
        visible={isModalFilter}
        onClose={toggleModal}
        handleFilter={handleFilter}
        handleClean={handleClean}
        valueFilter={valueFilter}
        valueRangePicker={valueRangePicker}
        setValueFilter={setValueFilter}
        setValueRangePicker={setValueRangePicker}
        expireValueRangePicker={expireValueRangePicker}
        setExpireValueRangePicker={setExpireValueRangePicker}
        numberRange={numberRange}
        setNumberRange={setNumberRange}
        setOptionByType={setOptionByType}
        optionByType={optionByType}
        nameContainsList={nameContainsList}
        setNameContainsList={setNameContainsList}
      />

      <Grid justifyContent="space-between" container spacing={2} columns={16}>
        <Grid item xs={8}>
          <Typography variant="h3" gutterBottom>
            Referral Programme
          </Typography>
          <Breadcrumbs
            routes={[typeRoutes('Referral Transactions', undefined, true)]}
          />
        </Grid>
        <Grid
          item
          xs={8}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {checkRbac(
            {
              permissionString:
                rbacPermissions.REFERRAL_PROGRAMME__REFERRAL_TRANSACTIONS__EXPORT,
            },
            <div
              style={{
                marginRight: '10px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                onClick={getExport}
                width="100px"
                variant="outlined"
                loading={isLoadingExport}
              >
                Export
              </Button>
            </div>
          )}
          <StyledStack direction="row" spacing={3}>
            {(searchParams.get('createdDateTime_lte') !== null ||
              searchParams.get('createdDateTime_gte') !== null) && (
              <Chip
                label={`${
                  formatLocalDateFromUTCTime(
                    searchParams.get('createdDateTime_gte'),
                    formatDateTime
                  ) ?? '...'
                } -
                    ${
                      formatLocalDateFromUTCTime(
                        searchParams.get('createdDateTime_lte'),
                        formatDateTime
                      ) ?? '...'
                    }`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('date');
                }}
              />
            )}

            {(searchParams.get('pointsExpireDateTime_lt') !== null ||
              searchParams.get('pointsExpireDateTime_gte') !== null) && (
              <Chip
                label={`${
                  formatLocalDateFromUTCTime(
                    searchParams.get('pointsExpireDateTime_gte'),
                    formatDate
                  ) ?? '...'
                } -
                    ${
                      formatLocalDateFromUTCTime(
                        searchParams.get('pointsExpireDateTime_lt'),
                        formatDate
                      ) ?? '...'
                    }`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('expireDate');
                }}
              />
            )}

            {searchParams.get('transactionId_eq') !== null && (
              <Chip
                label={searchParams.get('transactionId_eq')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('transactionId_eq');
                }}
              />
            )}

            {searchParams.get('pointsStatus_eq') !== null && (
              <Chip
                label={renderLabelChip(
                  Number(searchParams.get('pointsStatus_eq'))
                )}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('pointsStatus_eq');
                }}
              />
            )}

            {(searchParams.get('pointsRewarded_gte') !== null ||
              searchParams.get('pointsRewarded_lte') !== null) && (
              <Chip
                label={`${searchParams.get('pointsRewarded_gte') ?? '...'} -
                    ${searchParams.get('pointsRewarded_lte') ?? '...'}`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('pointsRewarded');
                }}
              />
            )}

            {searchParams.get('referralType_label') !== null && (
              <Chip
                label={searchParams.get('referralType_label')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('referralType_eq');
                }}
              />
            )}

            {searchParams.get('referralCampaignNumberId_eq') !== null && (
              <Chip
                label={searchParams.get('referralCampaignNumberId_eq')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('referralCampaignNumberId_eq');
                }}
              />
            )}

            {searchParams.get('referralTxnMembershipId_label') !== null && (
              <Chip
                label={searchParams.get('referralTxnMembershipId_label')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('referralTxnMembershipId_label');
                }}
              />
            )}

            {searchParams.get('accountId_eq') !== null && (
              <Chip
                label={searchParams.get('accountId_eq')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('accountId_eq');
                }}
              />
            )}

            {searchParams.get('processId_label') !== null && (
              <Chip
                label={searchParams.get('processId_label')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('processId_eq');
                }}
              />
            )}

            {searchParams.get('referralCodeUsed_eq') !== null && (
              <Chip
                label={searchParams.get('referralCodeUsed_eq')}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('referralCodeUsed_eq');
                }}
              />
            )}
          </StyledStack>
          <Tooltips title="Filter list">
            <IconButton
              aria-label="Filter list"
              size="large"
              onClick={toggleModal}
            >
              <FilterListIcon />
            </IconButton>
          </Tooltips>
        </Grid>
      </Grid>
      <Divider my={6} />

      <Table
        dataSource={dataSource}
        columns={columns}
        page={params._page}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        rowsPerPage={params._size}
        textNodata="There are no all transaction(s) matching the filter."
        order={order}
        orderBy={orderBy}
        dense={dense}
        isMultiCheckbox={false}
        count={totalPage}
        isLoading={isLoading}
      >
        {!error && (
          <TableBody>
            {dataSource?.map((row, index) => {
              return (
                <StyledTableRow
                  hover
                  role="checkbox"
                  key={index}
                  tabIndex={-1}
                  onMouseEnter={() => setFocusId(row.id)}
                  onMouseLeave={() => setFocusId(null)}
                >
                  <TableCell align="left">{row.transactionId}</TableCell>
                  <TableCell align="left">
                    {formatLocalDateFromUTCTime(
                      row.createdDateTime,
                      formatDateTime
                    )}
                  </TableCell>
                  <TableCell align="left">{row.accountId}</TableCell>
                  <TableCell align="left">{row.referralCode}</TableCell>
                  <TableCell align="left">
                    {row.referralCampaignNumberId}
                  </TableCell>
                  <TableCell align="left">{renderReferralType(row)}</TableCell>
                  <TableCell align="left">{renderStatus(row)}</TableCell>
                  <TableCell align="left">{row.pointsRewarded}</TableCell>
                  <TableCell align="left">
                    {renderExpiredDateTime(row)}
                  </TableCell>
                  <TableCell align="left">{renderPointsStatus(row)}</TableCell>
                  <TableCell
                    align="right"
                    padding="checkbox"
                    style={{paddingRight: '10px'}}
                  >
                    {renderAction(row.id)}
                  </TableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        )}
      </Table>
    </React.Fragment>
  );
}

export default ReferralTransactions;
